import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IResourceGroupResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceGroupResponseInstance'

export function mapResourceGroupResponseInstance(resourceGroup: IToJson<IResourceGroupResponseInstance>): IResourceGroupResponseInstance {
  return {
    ...resourceGroup,
  } as IResourceGroupResponseInstance // TODO: TS: Remove "as ..."
}

